"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-MapModeLegendContainer',
    legendItem: 'c-MapModeLegendItem',
    legendIcon: 'c-MapModeLegendItem__icon',
    legendText: 'c-MapModeLegendItem__text',
    legendIconLine: 'c-MapModeLegendItem__icon__line',
    legendCollectionLabelOverride: 'c-MapModeLegendItem__icon__label'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        position: 'relative',
        flexGrow: '1',
        maxHeight: '30%',
        padding: theme_1.DefaultTheme.space(1),
        overflow: 'auto'
    },
    _a[exports.CSS.legendItem] = {
        display: 'flex',
        height: '28px',
        boxSizing: 'border-box',
        padding: "".concat(theme_1.DefaultTheme.space(1), " ").concat(theme_1.DefaultTheme.space(2))
    },
    _a[exports.CSS.legendIcon] = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '32px',
        height: '100%'
    },
    _a[exports.CSS.legendIconLine] = {
        height: '4px',
        width: '100%'
    },
    _a[exports.CSS.legendCollectionLabelOverride] = {
        width: '100%',
        padding: 0,
        textAlign: 'center'
    },
    _a[exports.CSS.legendText] = {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '12px'
    },
    _a);
//# sourceMappingURL=map.mode.legend.style.js.map